import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ResetPassword.css';

import { ApiContext } from '../context/ApiContext';
const ResetPassword = () => {
    const [email, setEmail] = useState('');
    // const [password, setPassword] = useState('');

    const apiUrl = useContext(ApiContext);
    const navigate = useNavigate();
    const handleResetPassword = async () => {
        try {
            const response = await fetch(`${apiUrl}/api/v1/reset-password/request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email}),
            });

            if (response.ok) {
            // navigate('/reset-password/verify', { state: { email } });
            navigate(`/reset-password/verify?email=${encodeURIComponent(email)}`);
            } else {
                alert('ResetPassword Failed!');
            }
        } catch (error) {
            console.error('Error during login:', error);
            alert('An error occurred. Please try again.');
        }
    };

    return (
        <div className="ResetPassword">
            <h2>Forgot Password</h2>
            <form>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-buttons">
                    <button type="button" onClick={() => window.history.back()}>Back</button>
                    <button type="button" onClick={handleResetPassword}>Next</button>
                </div>
            </form>
        </div>
    );
};

export default ResetPassword;
